// Authentication
export const LOGIN = "/auth/token/";

export const GET_KPI_LIST = "/monitoring/uptime-logs/";
export const GET_MONITORING_PROJECT = "/monitoring/projects/";
export const GET_MONITORING_SITE = "monitoring/kpi-sites/";
export const GET_MONITORING_OPERATIONAL = "monitoring/operational/";

// Pulse
export const PULSE_OVERVIEW = "/pulse/overview/";
export const PULSE_PROJECTS = "/pulse/projects/";
export const PULSE_PORTALS = "/pulse/portals/";
export const PULSE_SAMPLES = "/pulse/samples/";
export const PULSE_PORTAL_RELIABILITY = (id) => `/pulse/portals/${id}/reliability/`;
export const PULSE_PORTAL_CHECK_HISTORY = (id) => `/pulse/portals/${id}/check-history/`;
export const PULSE_INCIDENTS = "/pulse/incidents/";
export const PULSE_HOURLY = "/pulse/aggregates/hourly/";
export const PULSE_DAILY = "/pulse/aggregates/daily/";
export const PULSE_REPORTS = "/pulse/reports/";
export const PULSE_POLL = "/pulse/poll/";
